<template>
    <header class="header">
        <div class="wrap header-inner">
            <div class="logo research-logo">
                <router-link to="/" aria-label="亚讯体育首页">
                    <img class="logo-mark" :src="siteLogo" alt="亚讯体育标志">
                    <span class="logo-copy"><b>亚讯体育</b><small>YAXUNTIYU.COM</small></span>
                </router-link>
            </div>
            <button type="button" :class="['mobile-nav-toggle',menuOpen?'open':'']" @click.stop="menuOpen=!menuOpen" aria-label="打开主导航"><i></i><i></i><i></i></button>
            <nav :class="['hdnav',menuOpen?'mobile-open':'']" aria-label="主导航">
                <router-link v-for="item in navList" :key="item.url" :class="isActive(item.url)?'active':''" :to="item.url" @click.native="menuOpen=false">
                    <span>{{item.name}}</span>
                </router-link>
            </nav>
            <div class="hdrge">
                <div class="search-shell" @click.stop>
                    <span class="search-label">亚讯检索</span>
                    <i class="search-icon"></i>
                    <input v-model="keyword" :placeholder="searchPlaceholder" @input="queueSearch" @focus="onSearchFocus" @keyup.enter="runSearch" @keyup.esc="closeSearch" autocomplete="off" aria-label="搜索球队、联赛或专家">
                    <button v-if="keyword" type="button" class="search-clear" @click="clearSearch">×</button>
                    <div class="search-panel" v-if="searchOpen">
                        <div class="search-state" v-if="searching"><span></span>正在检索赛事资料</div>
                        <template v-else>
                            <div class="search-title"><b>{{noResults?'没有相关内容':'当前页搜索结果'}}</b></div>
                            <div class="search-empty" v-if="noResults">没有找到“{{keyword}}”相关的球队、联赛或专家，请更换关键词。</div>
                            <router-link class="search-result" v-for="item in searchResults" :key="item.uuid" :to="'/recommend/'+item.uuid" @click.native="selectSearchResult">
                                <div class="search-teams">
                                    <team-badge :name="item.shangpan" :size="24"/><b>{{item.shangpan}}</b>
                                    <em>{{item.bifen || 'VS'}}</em>
                                    <team-badge :name="item.xiapan" :size="24"/><b>{{item.xiapan}}</b>
                                </div>
                                <div class="search-meta"><span>{{item.match_type}} · {{item.time}}</span><span>{{item.user.name}} · 7天胜率 {{item.user.winrate || 0}}%</span></div>
                            </router-link>
                        </template>
                    </div>
                </div>
                <button :class="['sign-pulse', isSign?'signed':'']" type="button" @click="toSign">
                    <span class="coin">✓</span><span class="sign-copy"><small>DAILY CHECK</small><b>{{isSign?'今日已签到':'签到得球币'}}</b></span>
                </button>
                <div class="lg" v-if="!islogin"><router-link to="/login"><small>ACCOUNT</small><b>登录</b></router-link></div>
                <div class="ui" v-else><router-link to="/my"><small>MEMBER</small><b>我的</b></router-link></div>
            </div>
        </div>
        <button v-if="menuOpen" class="mobile-nav-mask" type="button" aria-label="关闭导航" @click="menuOpen=false"></button>
    </header>
</template>

<script>
import TeamBadge from './team_badge'
import siteLogo from '../../assets/images/yaxun-sports-logo.svg'

export default {
    name: 'Header',
    components: {TeamBadge},
    data(){
        return {
            islogin: false, isSign: false, keyword: '', searching: false, searchOpen: false, menuOpen: false, siteLogo,
            searchResults: [], noResults: false, searchPlaceholder: '搜索球队、联赛或专家…', searchTimer: null, searchSeq: 0,
            navList: [
                {name:'首页', url:'/'}, {name:'专家贴士', url:'/recommend'}, {name:'专家排行', url:'/rank'},
                {name:'即时比分', url:'/bifen'}, {name:'体育资讯', url:'/news'}
            ]
        }
    },
    watch: {
        '$store.state.token'(v){
            this.islogin = Boolean(v)
            if(this.islogin) this.syncSignState()
            else this.isSign = false
        },
        '$route.path'(){ this.menuOpen = false; this.searchOpen = false }
    },
    mounted(){
        this.islogin = Boolean(this.$store.state.token)
        if(this.islogin) this.syncSignState()
        document.addEventListener('click', this.closeSearch)
    },
    beforeDestroy(){ document.removeEventListener('click', this.closeSearch); clearTimeout(this.searchTimer) },
    methods: {
        isActive(url){ return url === '/' ? this.$route.path === '/' : this.$route.path.indexOf(url) === 0 },
        onSearchFocus(){
            if(this.keyword || this.searchResults.length) this.searchOpen = true
            if(this.searchPlaceholder === '没有相关内容') this.searchPlaceholder = '搜索球队、联赛或专家…'
        },
        queueSearch(){
            clearTimeout(this.searchTimer)
            this.searchPlaceholder = '搜索球队、联赛或专家…'; this.noResults = false
            if(!this.keyword.trim()){ this.clearSearch(); return }
            this.searchTimer = setTimeout(this.runSearch, 350)
        },
        runSearch(){
            clearTimeout(this.searchTimer)
            if(!this.keyword.trim()) return
            const current = ++this.searchSeq
            this.searching = true; this.searchOpen = true
            this.$post(this.$api.recommend_list, {page:1, key:this.keyword, type:1}).then(res => {
                if(current !== this.searchSeq) return
                const list = res && res.code === 1 ? (res.data.recommend_list || []).slice(0, 6) : []
                if(list.length){ this.searchResults = list; this.noResults = false; this.searchOpen = true }
                else{ this.searchResults = []; this.noResults = true; this.searchOpen = true }
            }).catch(() => {
                if(current === this.searchSeq){ this.searchResults = []; this.noResults = true; this.searchOpen = true }
            }).finally(() => { if(current === this.searchSeq) this.searching = false })
        },
        clearSearch(){ this.keyword = ''; this.searchResults = []; this.noResults = false; this.searchOpen = false; this.searchPlaceholder = '搜索球队、联赛或专家…' },
        selectSearchResult(){ this.searchOpen = false; this.keyword = '' },
        closeSearch(){ this.searchOpen = false },
        syncSignState(){
            this.$post(this.$api.home, {header:1}).then(res => { if(res && res.code === 1) this.isSign = Boolean(res.data.isSign) }).catch(() => {})
        },
        toSign(){
            if(this.isSign) return
            if(!this.$store.state.token){
                this.closeSearch()
                if(this.$route.path !== '/login') this.$router.push({path:'/login', query:{redirect:this.$route.fullPath}})
                return
            }
            this.$toast.loading()
            this.$post(this.$api.sign).then(res => {
                if(res.code === 1){ this.isSign = true; this.$toast.success(res.msg) }
                else this.$toast.fail(res.msg)
            }).catch(() => this.$toast.fail('签到失败，请稍后重试'))
        }
    }
}
</script>

<style scoped></style>
